<template>
  <div class="util-latest-list">
    <div class="util-card" v-for="(row,i) in listdata" :key="i">
      <div class="util-card-date">
        <strong>{{ dayjs(row.date).format("D") }}</strong>
        <span>{{ dayjs(row.date).format("MMM") }}</span>
        <span>{{ dayjs(row.date).format("YYYY") }}</span>
      </div>
      <div class="util-card-detail ucdg">
        <div class="ucdg-item">
          <span>Boiler 1</span>
          <p>
            <strong>{{ nom(row.boiler_1_m3) }}</strong>  m<sup>3</sup>
          </p>
        </div>
        <div class="ucdg-item">
          <span>Boiler 2</span>
          <p>
            <strong>{{ nom(row.boiler_2_m3) }}</strong>  m<sup>3</sup>
          </p>
        </div>
        <div class="ucdg-item">
          <span>Boiler 3</span>
          <p>
            <strong>{{ nom(row.boiler_3_m3) }}</strong>  m<sup>3</sup>
          </p>
        </div>
        <div class="ucdg-item">
          <span>Chiller</span>
          <p>
            <strong>{{ nom(row.chiller_m3) }}</strong>  m<sup>3</sup>
          </p>
        </div>
        <div class="ucdg-item">
          <span>Total PGN</span>
          <p>
            <strong>{{ nom(row.total_pgn) }}</strong>  m<sup>3</sup>
          </p>
        </div>
        <div class="ucdg-item">
          <span>Total</span>
          <p class="pgreen"> 
            <strong>{{ nom(row.total_mmbtu) }}</strong>  MMBTU
          </p>
        </div>

      </div>
    </div>
  </div>
</template>

<script lang="js">
import Vue from "vue";
import dayjs from "dayjs";
import { Prop } from "vue-property-decorator";
import { Component } from "vue-property-decorator";
import { nom  } from "@/api/api";
@Component({})
export default class UtilitiesListrikList extends Vue {
  @Prop () listdata;
  dayjs = dayjs
  nom = nom
}
</script>
